import Vue from 'vue'

const assets = {
  images: require('./modules/images'),
  icons: require('./modules/icons'),
  logos: require('./modules/logos')
}

export const bootstrap = async () => {
  Vue.use({
    install (Vue) {
      Vue.prototype.$assets = assets
    }
  })
}

export default assets
